module.exports={author:"Noah Falck",date:"08/5/2021",publishDate:"08/5/2021",highlighted:!1,tags:"",badge:"",title:"Onding"};